import React, { FC, useEffect, useState } from 'react';
import Header from '../../components/layout/header/Header';
import { Button, Container } from 'react-bootstrap';
import { useIntl } from 'react-intl';
import useOrganizationsList from '../../hooks/api/organization/useOrganizationsList';
import _ from 'lodash';
import AddOrganizationModal from '../../components/layout/navbar/organizationMenu/addOrganizationModal/AddOrganizationModal';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store';
import { history } from '../../history';
import { setOrganization } from '../../slices/organization';
import Avatar from '../../components/layout/avatar/Avatar';
import LoadingSpinner from '../../components/layout/loadingSpinner/LoadingSpinner';
import { DefaultPage } from '../../components/layout/navbar/Navbar';

const OrganizationSelection: FC = () => {
  const [showModalOrganization, setShowModalOrganization] = useState<boolean>(false);
  const { getOrganizations, isLoading } = useOrganizationsList();
  const organizations = useSelector((state: RootState) => state.organization.organizations);
  const intl = useIntl();
  const dispatch = useDispatch();

  useEffect(() => {
    getOrganizations();
  }, []);

  const handleSelectedOrganization = (organization) => {
    dispatch(setOrganization(organization));
    history.replace(DefaultPage);
  };

  return (
    <React.Fragment>
      <Header></Header>
      <div className="organization-selection">
        <div className="page-content">
          {isLoading && <LoadingSpinner />}
          {!isLoading && (
            <Container fluid>
              <div className="title-wrapper">
                <span>{intl.formatMessage({ id: 'organizationPage.selection.title' })}</span>
              </div>
              <div className="organization-wrapper">
                <div className="row">
                  {_.map(organizations, (organization) => {
                    return (
                      <div className="col-6 col-sm-4">
                        <Button
                          onClick={() => {
                            handleSelectedOrganization(organization);
                          }}
                        >
                          <div className="image-wrapper">
                            <div className="avatar-wrapper">
                              <Avatar src={organization.avatar} width={150} height={150}></Avatar>
                            </div>
                          </div>
                          <div className="name-wrapper">
                            <span className="organization-name">{organization.name}</span>
                          </div>
                        </Button>
                      </div>
                    );
                  })}
                </div>
              </div>
              <div className="button-wrapper">
                <Button onClick={() => setShowModalOrganization(true)}>
                  <span className="mdi mdi-plus"></span>
                  {intl.formatMessage({ id: 'organizationPage.selection.addOrganization' })}
                </Button>
              </div>
            </Container>
          )}
        </div>
      </div>
      <AddOrganizationModal
        show={showModalOrganization}
        onClose={() => {
          setShowModalOrganization(false);
        }}
      ></AddOrganizationModal>
    </React.Fragment>
  );
};

export default OrganizationSelection;
